// spaces out elements alongside each other
export const Aside = ({
  flex = "d-md-flex",
  justify = "justify-content-between",
  mobile = "d-block",
  className = "",
  children,
}) => <aside className={`${flex} ${justify} ${mobile} ${className}`}>{children}</aside>;
